
export default function Affinity() {
  return (
    <section className="py-14 md:py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 md:mb-8" style={{ lineHeight: '1.5' }}>
            「機械を壊したくない…」
            <br />
            <span className="affinity-title-line whitespace-nowrap text-xl md:text-4xl lg:text-5xl">その一瞬の迷いが命取りになる</span>
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 lg:p-14">
          <p className="text-base md:text-xl text-gray-800 leading-relaxed mb-8 md:mb-10 text-center">
            工場長や安全管理者の皆様は、常にジレンマと戦っています。
          </p>

          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-8 md:mb-10">
            <div className="flex-shrink-0">
              <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-gray-200 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20factory%20manager%20wearing%20helmet%20and%20safety%20vest%20standing%20in%20industrial%20plant%20with%20serious%20worried%20expression%20on%20face%20portrait%20photo%20professional%20lighting%20clean%20background&width=400&height=400&seq=factory-manager-001&orientation=squarish"
                  alt="工場長イメージ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="relative bg-gradient-to-r from-gray-100 to-gray-50 rounded-2xl p-6 md:p-8 flex-1 w-full">
              <div className="hidden md:block absolute left-[-16px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[14px] border-t-transparent border-b-[14px] border-b-transparent border-r-[16px] border-r-gray-100"></div>
              <div className="block md:hidden absolute top-[-14px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[14px] border-l-transparent border-r-[14px] border-r-transparent border-b-[14px] border-b-gray-100"></div>
              <p className="text-lg md:text-2xl lg:text-3xl font-bold text-gray-900 text-center leading-relaxed">
                「ボヤなら消せる。
                <br />
                でも、消火器を使ったら
                <br />
                このラインはどうなる？」
              </p>
            </div>
          </div>

          <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 md:p-10 mb-8 md:mb-10 text-center">
            <p className="affinity-hesitation text-lg md:text-2xl lg:text-3xl text-gray-900 font-bold" style={{ lineHeight: '1.5' }}>
              <span className="affinity-hesitation-mobile">
                その<br />
                <span className="text-red-600 text-xl md:text-3xl lg:text-4xl font-extrabold">「躊躇（ためら）い」</span><br />
                こそが<br />
                初期消火の遅れを招き<br />
                <span className="text-red-600 text-xl md:text-3xl lg:text-4xl font-extrabold">大事故に繋がる最大の要因</span><br />
                です
              </span>
              <span className="affinity-hesitation-pc">
                その<span className="text-red-600 text-xl md:text-3xl lg:text-4xl font-extrabold">「躊躇（ためら）い」</span>こそが
                <br />
                初期消火の遅れを招き
                <br />
                <span className="text-red-600 text-xl md:text-3xl lg:text-4xl font-extrabold">大事故に繋がる最大の要因</span>です
              </span>
            </p>
          </div>

          <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-8 md:p-14 text-center">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8">
              <i className="ri-lightbulb-line text-3xl md:text-4xl text-white"></i>
            </div>
            <p className="text-xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 md:mb-6">もし、こんな方法があるとしたら？</p>
            <p className="text-base md:text-2xl lg:text-3xl text-green-700 font-semibold">
              「機械を壊さず、部屋も汚さず、火だけを消す」
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 flex items-center justify-center space-x-4">
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse delay-100"></div>
          <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse delay-200"></div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .affinity-title-line {
            font-size: 1.1rem !important;
            white-space: nowrap;
          }
          .affinity-hesitation-mobile {
            display: block;
          }
          .affinity-hesitation-pc {
            display: none;
          }
          .affinity-hesitation {
            line-height: 1.8 !important;
          }
        }
        @media (min-width: 769px) {
          .affinity-hesitation-mobile {
            display: none;
          }
          .affinity-hesitation-pc {
            display: block;
          }
        }
      `}</style>
    </section>
  );
}
